import { useContext } from 'react';
import { BreadcrumbsContext } from './breadcrumbsContext';

export const useBreadcrumbs = () => {
  const context = useContext(BreadcrumbsContext);

  if (context === null) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
  }

  return context;
};
